import { Outlet, useNavigate, useLocation } from "react-router-dom";

import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation';
import PropaneTankIcon from '@mui/icons-material/PropaneTank';

export const Home = () => {
  const navigate = useNavigate();

  return (
    <div>
        <Stack
          direction="column"
          justifyContent="center"
          alignItems="stretch"
          spacing={1}
        >
          <Box display="flex" justifyContent="space-between" p={2}>
            <Typography variant="h5">Westco Home</Typography>

            <Box display="flex"></Box>
          </Box>

          <Button
            variant="contained"
            size="large"
            style={{maxHeight: '200px', minHeight: '150px'}}
            startIcon={<LocalGasStationIcon style={{fontSize: 48}} />}
            href="http://westco-fuel.cehm-systems.app/"
            target="_blank"
          >
            <Typography variant="h5">Fuel Reporting</Typography>
          </Button>
          <Button
            variant="contained"
            size="large"
            style={{maxHeight: '200px', minHeight: '150px'}}
            startIcon={<PropaneTankIcon style={{fontSize: 48}} />}
            href="http://westco-propane.cehm-systems.app/"
            target="_blank"
          >
            <Typography variant="h5">Propane Reporting</Typography>
          </Button>
        </Stack>
      <Outlet />
    </div>
  );
};
